import React from 'react'

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      fill='none'
      viewBox='0 0 24 24'
    >
      <path
        fill='#202020'
        d='M12 16.943c3.403 0 6.38 1.464 8 3.648l-1.712.81c-1.318-1.562-3.642-2.599-6.289-2.599-2.646 0-4.97 1.037-6.288 2.599L4 20.591c1.62-2.185 4.596-3.648 8-3.648zM12 3a4.648 4.648 0 014.647 4.648v2.788a4.648 4.648 0 01-4.446 4.643l-.202.005a4.648 4.648 0 01-4.647-4.648V7.648a4.648 4.648 0 014.446-4.643L11.999 3zm0 1.86a2.788 2.788 0 00-2.784 2.624l-.005.164v2.788a2.788 2.788 0 005.572.164l.005-.164V7.648A2.789 2.789 0 0012 4.859z'
      ></path>
    </svg>
  )
}

export default Icon
